import React, {useState} from "react"
import {  Header, Button, Segment, Form , label,Input, Comment} from 'semantic-ui-react'

const CustomInput=({cancellor, parentId, value, edit, submit, handleCancel})=>{
    
    const [text, setText] = useState(value)

    const handleChange = (e) => {
        setText(e.target.value)
      }
    
    return(  
        
        <Segment>
        <Input
          value={text}
          placeholder='Escribe tu comentario'
          onChange={handleChange}
        />
        
       
          <Button
            onClick={() =>submit(cancellor, text, parentId, edit, setText)}
            type='button'
            disabled={!text}
          >
            Agregar
          </Button>
            <Button onClick={() => handleCancel(cancellor,edit)}>
              Cancelar
            </Button>
       </Segment>
    )
}

export default CustomInput